import { FC } from "react";
import { AnyTask, Market } from "tm-shared/types";
import {
    isTaskAddPhoto,
    isTaskAssignment,
    isTaskAssortmentMatrix,
    isTaskDMP,
    isTaskPromoTagPhotos,
    isTaskRejectProducts,
    isTaskSaleAdditional,
    isTaskSetGeoLocation,
    isTaskShelfSize,
    isTaskStartVisit,
    isTaskTakeDebt,
    isTaskUpdateMarketInfo,
    isTaskUpdateProductBalances,
} from "tm-shared/utils";

import { AddPhotoViewModal } from "../AddPhotoViewModal";
import { AssignmentViewModal } from "../AssignmentViewModal";
import { AssortmentMatrixViewModal } from "../AssortmentMatrixViewModal";
import { DmpViewModal } from "../DmpViewModal";
import { PromoTagPhotosViewModal } from "../PromoTagPhotosViewModal";
import { RejectProductsViewModal } from "../RejectProductsViewModal";
import { SaleViewModal } from "../SaleViewModal";
import { SetGeoLocationViewModal } from "../SetGeoLocationViewModal";
import { ShelfSizeViewModal } from "../ShelfSizeViewModal";
import { StartVisitViewModal } from "../StartVisitViewModal";
import { TakeDebtViewModal } from "../TakeDebtViewModal";
import { UpdateMarketInfoViewModal } from "../UpdateMarketInfoViewModal";
import { UpdateProductBalancesViewModal } from "../UpdateProductBalancesViewModal";

interface TasksModalsContainerProps {
    modal: {
        task: AnyTask;
        market: Market;
    } | null;
    onClose: () => void;
}

export const TasksModalsContainer: FC<TasksModalsContainerProps> = ({
    modal,
    onClose,
}) => {
    if (!modal) return null;

    const { task, market } = modal;

    if (isTaskStartVisit(task)) {
        return <StartVisitViewModal onClose={onClose} task={task} />;
    }

    if (isTaskSaleAdditional(task)) {
        return <SaleViewModal onClose={onClose} task={task} />;
    }

    if (isTaskUpdateProductBalances(task)) {
        return <UpdateProductBalancesViewModal onClose={onClose} task={task} />;
    }

    if (isTaskTakeDebt(task)) {
        return <TakeDebtViewModal onClose={onClose} task={task} />;
    }

    if (isTaskUpdateMarketInfo(task)) {
        return (
            <UpdateMarketInfoViewModal
                onClose={onClose}
                task={task}
                market={market}
            />
        );
    }

    if (isTaskShelfSize(task)) {
        return <ShelfSizeViewModal onClose={onClose} task={task} />;
    }

    if (isTaskSetGeoLocation(task)) {
        return <SetGeoLocationViewModal onClose={onClose} task={task} />;
    }

    if (isTaskDMP(task)) {
        return <DmpViewModal onClose={onClose} task={task} market={market} />;
    }

    if (isTaskPromoTagPhotos(task)) {
        return (
            <PromoTagPhotosViewModal
                onClose={onClose}
                task={task}
                market={market}
            />
        );
    }

    if (isTaskAssignment(task)) {
        return (
            <AssignmentViewModal
                onClose={onClose}
                task={task}
                market={market}
            />
        );
    }

    if (isTaskAssortmentMatrix(task)) {
        return (
            <AssortmentMatrixViewModal
                onClose={onClose}
                task={task}
                market={market}
            />
        );
    }

    if (isTaskAddPhoto(task)) {
        return <AddPhotoViewModal onClose={onClose} task={task} />;
    }

    if (isTaskRejectProducts(task)) {
        return <RejectProductsViewModal onClose={onClose} task={task} />;
    }
};
